import { SET_FORM, RESET_FORM } from "../actions/form";

const initialState = {
  unlimitedInternet: null,
  wifiRouter: null,
  homePhone: null,
  first_name: "",
  last_name: "",
  email: "",
  confirm_email: "",
  phone: "",
  promotion: null,
  activationDate: null,
  activationDateUser: null,
  timeslot: null,
  otherTimeSlot: false,
  job_id: null,
  unlimitedInternetObj: {},
  wifiRouterObj: {},
  homePhoneObj: {},
  promotionObj: {},
  timeslotObj: {},
  timeslotType: null,
  deliveryDate: null,
  heardAboutUs: null
};

const form = (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM:
      return { ...state, ...action.payload };
    case RESET_FORM:
      return initialState;
    default:
      return state;
  }
};

export default form;



// WEBPACK FOOTER //
// ./src/store/reducers/form.js